// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._3wpBe{width:650px;width:65rem}.gIfc1:after{bottom:4px;color:#787676;font-size:14px;font-size:1.4rem;height:20px;position:absolute}html[dir=ltr] .gIfc1:after{right:12px}html[dir=rtl] .gIfc1:after{left:12px}.Hgcu5:after{content:\"mg/dL\"}.KS18B:after{content:\"mmol/L\"}", ""]);
// Exports
exports.locals = {
	"glucoseRanges": "_3wpBe",
	"glucoseLevel__unitSymbol": "gIfc1",
	"glucoseLevel__unitSymbol--mgdl": "Hgcu5",
	"glucoseLevel__unitSymbol--mmolL": "KS18B"
};
module.exports = exports;
